import { APICallV3Get } from 'reactApp/api/APICall';

export class BindListAPICall extends APICallV3Get {
    _method = 'billing/bind/list';
}
